import { render, staticRenderFns } from "./chinese_home.vue?vue&type=template&id=0f56ec21&scoped=true&"
import script from "./chinese_home.vue?vue&type=script&lang=js&"
export * from "./chinese_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f56ec21",
  null
  
)

export default component.exports